// import styled from "styled-components"; // Não utilizado atualmente
import React from 'react'
// import CryptoJS from 'crypto-js'; // Não utilizado atualmente
// import PermissionGate from "../../services/PermissionGate"; // Não utilizado atualmente
import { useTranslation } from 'react-i18next';

import { useFormik } from "formik";
import * as Yup from "yup";

import * as AiIcons from 'react-icons/ai';
import { updateTempoEntregaEmpresa } from "../../services/api";
// import AsyncSelect from "react-select/async"; // Não utilizado atualmente

import { AuthContext } from "../../contexts/auth";
import { useEffect, useContext, useState } from "react";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

// import { useNavigate } from "react-router-dom"; // Não utilizado atualmente
import './styles.css';

// Removendo os styled-components antigos - agora usaremos CSS moderno

const ModalEditTempoEntrega = ({setEditTempoEntregaEmpresa, showEditTempoEntregaEmpresa, setRefresh,
    _idEmpresaEdit,
    tempoBalcaoMinBD,
    tempoBalcaoMaxBD,
    tempoEntregaMinBD,
    tempoEntregaMaxBD,
    tipoImpressao
}) => {

    const { t } = useTranslation('common');
    const { user } = useContext(AuthContext);
    const empresa = localStorage.getItem('empresa')
    const empresaParse = JSON.parse(empresa)
    const empresaObjId = empresaParse._id;
    // const idEmpresa = empresaParse.id_empresa // Não utilizado atualmente

    // const [resetPassword, setResetPassword] = useState(false); // Não utilizado atualmente


   
    var [tempoBalcaoMin, setTempoBalcaoMin] = useState(tempoBalcaoMinBD);
    var [tempoBalcaoMax, setTempoBalcaoMax] = useState(tempoBalcaoMaxBD);
    var [tempoEntregaMin, setTempoEntregaMin] = useState(tempoEntregaMinBD);
    var [tempoEntregaMax, setTempoEntregaMax] = useState(tempoEntregaMaxBD);
    var [switchState, setSwitchState] = useState(tipoImpressao==='manual'?false:true);

    useEffect(() => {
        (async () => {
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log()
           
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("dados>",response.data.vinculo.tempoBalcaoMin);
            setTempoBalcaoMin(tempoBalcaoMinBD);
            setTempoBalcaoMax(tempoBalcaoMaxBD);
            setTempoEntregaMin(tempoEntregaMinBD);
            setTempoEntregaMax(tempoEntregaMaxBD);
            setSwitchState(tipoImpressao==='manual'?false:true);
           
        })();
    //eslint-disable-next-line
    },[tempoBalcaoMinBD, tipoImpressao]);
  

    const handleSwitchChange = (event) => {
        setSwitchState(event.target.checked);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(event.target.checked);
    };

    //Validações
    const SignUpSchema = Yup.object().shape({
        tempoBalcaoMin: Yup.number().required(t('validation.required')),
        tempoBalcaoMax: Yup.number().moreThan(Yup.ref("tempoBalcaoMin"), t('deliveryTime.maxMustBeGreaterThanMin')).required(t('validation.required')),
        tempoEntregaMin: Yup.number().required(t('validation.required')),
        tempoEntregaMax: Yup.number().moreThan(Yup.ref("tempoEntregaMin"), t('deliveryTime.maxMustBeGreaterThanMin')).required(t('validation.required')),
    });


    const formik = useFormik({
        validationSchema: SignUpSchema,
        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: true,
        //enableReinitialize: showEditTempoEntregaEmpresa,
        initialValues: {
          //nome: nome,
          tempoBalcaoMin: tempoBalcaoMin,
          tempoBalcaoMax: tempoBalcaoMax,
          tempoEntregaMin: tempoEntregaMin,
          tempoEntregaMax: tempoEntregaMax
        },
        onSubmit: (values) => {
          //alert(JSON.stringify(values, null, 2));
          //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(values);
          //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("RoleEdit:::",roleEdit);

          const tempoBalcaoMin_ = tempoBalcaoMin;        
          const tempoBalcaoMax_ = tempoBalcaoMax;
          const tempoEntregaMin_ = tempoEntregaMin;
          const tempoEntregaMax_ = tempoEntregaMax;          

          process.env.REACT_APP_ISDEVELOP === 'true' && console.log("DADOS TESTE::",tempoBalcaoMin_, tempoBalcaoMax_, tempoEntregaMin_, tempoEntregaMax_)
          //const vinculo='';
          // var tipo = ""; // Não utilizado atualmente
          //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("values.tipo:::",values.tipo)
          // if(values.tipo==="Administrador" || values.tipo==="Admin"){
          //   tipo = "Admin";
          // }
          // if(values.tipo==="Empresa" || values.tipo==="empresa"){
          //   tipo = "empresa";
          // }
          // if(values.tipo==="Revenda" || values.tipo==="revenda"){
          //   tipo = "revenda";
          // }
          
          handleSubmitAPI(tempoBalcaoMin_, tempoBalcaoMax_, tempoEntregaMin_, tempoEntregaMax_);
          
        },
    });

    // Lógica para atualizar os dados do usuário no localStorage
    // Get the existing data
    // const secretKey = 'my-custom-secret-key:1af0addcce4b56f753ed10c285667ad031bae57af19747f576b05312b8cf85be';
    // const userEncrypted = localStorage.getItem('user')
    // var existing = CryptoJS.AES.decrypt(userEncrypted, secretKey).toString(CryptoJS.enc.Utf8);
    // //var existing = localStorage.getItem('user');
    // // Convert the localStorage string to an array
    // existing = JSON.parse(existing); // Não utilizado atualmente

    /*const handleSubmit = () => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("TESTE SUBMIT:", tempoBalcaoMin)
    }*/

    const handleSubmitAPI = (tempoBalcaoMin_, tempoBalcaoMax_, tempoEntregaMin_, tempoEntregaMax_) => {
        const userID = user._id;
        let tipo_impressao = "";
        if(switchState){
            tipo_impressao = "automatico";
        } else {
            tipo_impressao = "manual";
        }
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(_idEmpresaEdit, userID, tempoBalcaoMin_, tempoBalcaoMax_, tempoEntregaMin_, tempoEntregaMax_, tipo_impressao);
        
        updateTempoEntregaEmpresa( userID, empresaObjId, _idEmpresaEdit, tempoBalcaoMin_.toString(), tempoBalcaoMax_.toString(), tempoEntregaMin_.toString(), tempoEntregaMax_.toString(), tipo_impressao).then(cast => {
        
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Tempo de entrega editado com Sucesso!:::",cast)
            if(cast.status===200){
                toast(cast.data.msg,{ autoClose: 5000 , type: "success"});
                //navigate("/list-users");
                setRefresh(true);
                setEditTempoEntregaEmpresa(!showEditTempoEntregaEmpresa);
            }else{
                toast(cast.data.msg,{ autoClose: 5000 , type: "error"});
            }
                
        }).catch(err => {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Ocorreu algum erro no servidor!',err);
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(err.response.data.msg);
            toast(err.response.data.msg,{ autoClose: 5000 , type: "error"});
        });
              
    }

    const closeEditTempoEntrega = () => setEditTempoEntregaEmpresa(!showEditTempoEntregaEmpresa);

    const handleChange = (type, value, delta) => {
        if (value + delta >= 0) {
            if (type === 'tempoBalcaoMin') {
                setTempoBalcaoMin(Number(value) + delta);
            } else if (type === 'tempoBalcaoMax') {
                setTempoBalcaoMax(Math.max(Number(value) + delta, tempoBalcaoMin));
            } else if (type === 'tempoEntregaMin') {
                setTempoEntregaMin(Number(value) + delta);
            } else if (type === 'tempoEntregaMax') {
                setTempoEntregaMax(Math.max(Number(value) + delta, tempoEntregaMin));
            }
        }
    };
    
    const handleBlur = (type, value) => {
        if (type === 'tempoBalcaoMin') {
            if (value > tempoBalcaoMax) {
                setTempoBalcaoMin(tempoBalcaoMax);
            }
        } else if (type === 'tempoBalcaoMax') {
            if (value < tempoBalcaoMin) {
                setTempoBalcaoMax(tempoBalcaoMin);
            }
        } else if (type === 'tempoEntregaMin') {
            if (value > tempoEntregaMax) {
                setTempoEntregaMin(tempoEntregaMax);
            }
        } else if (type === 'tempoEntregaMax') {
            if (value < tempoEntregaMin) {
                setTempoEntregaMax(tempoEntregaMin);
            }
        }
    };
    
    const handleDecrement = (type) => {
        handleChange(type, type === 'tempoBalcaoMin' ? tempoBalcaoMin : (type === 'tempoBalcaoMax' ? tempoBalcaoMax : (type === 'tempoEntregaMin' ? tempoEntregaMin : tempoEntregaMax)), -1);
    };
    
    const handleIncrement = (type) => {
        handleChange(type, type === 'tempoBalcaoMin' ? tempoBalcaoMin : (type === 'tempoBalcaoMax' ? tempoBalcaoMax : (type === 'tempoEntregaMin' ? tempoEntregaMin : tempoEntregaMax)), 1);
    };


    return (
        <div className={`modal-tempo-entrega-overlay ${showEditTempoEntregaEmpresa ? 'hidden' : ''}`}>
            <div className="modal-tempo-entrega-container">
                {/* Header do Modal */}
                <div className="modal-tempo-entrega-header">
                    <button
                        className="modal-tempo-entrega-close-btn"
                        type="button"
                        onClick={closeEditTempoEntrega}
                        aria-label={t('buttons.close')}
                    >
                        <AiIcons.AiOutlineClose />
                    </button>
                    <div className="modal-tempo-entrega-header-icon">
                        <AiIcons.AiOutlineClockCircle />
                    </div>
                    <h4>{t('deliveryTime.title')}</h4>
                    <p className="modal-tempo-entrega-subtitle">{t('deliveryTime.subtitle')}</p>
                </div>

                {/* Conteúdo do Modal */}
                <div className="modal-tempo-entrega-content">
                    <form id="tempo-entrega-form" onSubmit={formik.handleSubmit}>

                        {/* Seção Retirada no Balcão */}
                        <div className="form-section">
                            <div className="section-header">
                                <div className="section-icon section-icon-pickup">
                                    <AiIcons.AiOutlineShop />
                                </div>
                                <h3 className="section-title">{t('deliveryTime.counterPickup')}</h3>
                                <div className="section-divider"></div>
                            </div>

                            <div className="input-group-modern">
                                <div className="input-field-modern">
                                    <label className="input-label-modern">{t('deliveryTime.minTime')}</label>
                                    <div className="number-input-container">
                                        <button
                                            type="button"
                                            className={`number-btn ${tempoBalcaoMin === 0 ? 'disabled' : ''}`}
                                            onClick={() => handleDecrement("tempoBalcaoMin")}
                                            disabled={tempoBalcaoMin === 0}
                                        >
                                            <AiIcons.AiOutlineMinus />
                                        </button>
                                        <input
                                            id='tempoBalcaoMin'
                                            name="tempoBalcaoMin"
                                            type="number"
                                            className="number-input"
                                            onKeyDown={(evt) =>
                                                ['e', 'E', '-', '.', ','].includes(evt.key) && evt.preventDefault()
                                            }
                                            value={tempoBalcaoMin}
                                            onChange={(e) => setTempoBalcaoMin(e.target.value)}
                                            onBlur={() => handleBlur('tempoBalcaoMin', tempoBalcaoMin)}
                                            max={9999}
                                            min={0}
                                        />
                                        <button
                                            type="button"
                                            className="number-btn"
                                            onClick={() => handleIncrement("tempoBalcaoMin")}
                                        >
                                            <AiIcons.AiOutlinePlus />
                                        </button>
                                    </div>
                                    {formik.errors.tempoBalcaoMin && (
                                        <div className="error-message-modern">{formik.errors.tempoBalcaoMin}</div>
                                    )}
                                </div>

                                <div className="input-field-modern">
                                    <label className="input-label-modern">{t('deliveryTime.maxTime')}</label>
                                    <div className="number-input-container">
                                        <button
                                            type="button"
                                            className={`number-btn ${tempoBalcaoMax === 0 || tempoBalcaoMax <= tempoBalcaoMin ? 'disabled' : ''}`}
                                            onClick={() => handleDecrement("tempoBalcaoMax")}
                                            disabled={tempoBalcaoMax === 0 || tempoBalcaoMax <= tempoBalcaoMin}
                                        >
                                            <AiIcons.AiOutlineMinus />
                                        </button>
                                        <input
                                            id='tempoBalcaoMax'
                                            name="tempoBalcaoMax"
                                            type="number"
                                            className="number-input"
                                            onKeyDown={(evt) =>
                                                ['e', 'E', '-', '.', ','].includes(evt.key) && evt.preventDefault()
                                            }
                                            value={tempoBalcaoMax}
                                            onChange={(e) => setTempoBalcaoMax(e.target.value)}
                                            onBlur={() => handleBlur('tempoBalcaoMax', tempoBalcaoMax)}
                                            max={9999}
                                            min={0}
                                        />
                                        <button
                                            type="button"
                                            className="number-btn"
                                            onClick={() => handleIncrement("tempoBalcaoMax")}
                                        >
                                            <AiIcons.AiOutlinePlus />
                                        </button>
                                    </div>
                                    {formik.errors.tempoBalcaoMax && (
                                        <div className="error-message-modern">{formik.errors.tempoBalcaoMax}</div>
                                    )}
                                </div>
                            </div>
                        </div>


                        {/* Seção Entrega Delivery */}
                        <div className="form-section">
                            <div className="section-header">
                                <div className="section-icon section-icon-delivery">
                                    <AiIcons.AiOutlineCar />
                                </div>
                                <h3 className="section-title">{t('deliveryTime.delivery')}</h3>
                                <div className="section-divider"></div>
                            </div>

                            <div className="input-group-modern">
                                <div className="input-field-modern">
                                    <label className="input-label-modern">{t('deliveryTime.minTime')}</label>
                                    <div className="number-input-container">
                                        <button
                                            type="button"
                                            className={`number-btn ${tempoEntregaMin === 0 ? 'disabled' : ''}`}
                                            onClick={() => handleDecrement("tempoEntregaMin")}
                                            disabled={tempoEntregaMin === 0}
                                        >
                                            <AiIcons.AiOutlineMinus />
                                        </button>
                                        <input
                                            id='tempoEntregaMin'
                                            name="tempoEntregaMin"
                                            type="number"
                                            className="number-input"
                                            onKeyDown={(evt) =>
                                                ['e', 'E', '-', '.', ','].includes(evt.key) && evt.preventDefault()
                                            }
                                            value={tempoEntregaMin}
                                            onChange={(e) => setTempoEntregaMin(e.target.value)}
                                            onBlur={() => handleBlur('tempoEntregaMin', tempoEntregaMin)}
                                            max={9999}
                                            min={0}
                                        />
                                        <button
                                            type="button"
                                            className="number-btn"
                                            onClick={() => handleIncrement("tempoEntregaMin")}
                                        >
                                            <AiIcons.AiOutlinePlus />
                                        </button>
                                    </div>
                                    {formik.errors.tempoEntregaMin && (
                                        <div className="error-message-modern">{formik.errors.tempoEntregaMin}</div>
                                    )}
                                </div>

                                <div className="input-field-modern">
                                    <label className="input-label-modern">{t('deliveryTime.maxTime')}</label>
                                    <div className="number-input-container">
                                        <button
                                            type="button"
                                            className={`number-btn ${tempoEntregaMax === 0 || tempoEntregaMax <= tempoEntregaMin ? 'disabled' : ''}`}
                                            onClick={() => handleDecrement("tempoEntregaMax")}
                                            disabled={tempoEntregaMax === 0 || tempoEntregaMax <= tempoEntregaMin}
                                        >
                                            <AiIcons.AiOutlineMinus />
                                        </button>
                                        <input
                                            id='tempoEntregaMax'
                                            name='tempoEntregaMax'
                                            type="number"
                                            className="number-input"
                                            onKeyDown={(evt) =>
                                                ['e', 'E', '-', '.', ','].includes(evt.key) && evt.preventDefault()
                                            }
                                            value={tempoEntregaMax}
                                            onChange={(e) => setTempoEntregaMax(e.target.value)}
                                            onBlur={() => handleBlur('tempoEntregaMax', tempoEntregaMax)}
                                            max={9999}
                                            min={0}
                                        />
                                        <button
                                            type="button"
                                            className="number-btn"
                                            onClick={() => handleIncrement("tempoEntregaMax")}
                                        >
                                            <AiIcons.AiOutlinePlus />
                                        </button>
                                    </div>
                                    {formik.errors.tempoEntregaMax && (
                                        <div className="error-message-modern">{formik.errors.tempoEntregaMax}</div>
                                    )}
                                </div>
                            </div>
                        </div>


                        {/* Seção Aceite Automático */}
                        <div className="form-section">
                            <div className="section-header">
                                <div className="section-icon section-icon-auto">
                                    <AiIcons.AiOutlineThunderbolt />
                                </div>
                                <h3 className="section-title">{t('deliveryTime.autoAccept')}</h3>
                                <div className="section-divider"></div>
                            </div>

                            <div className="switch-container-modern">
                                <label className="switch-modern">
                                    <input
                                        type="checkbox"
                                        checked={switchState}
                                        onChange={handleSwitchChange}
                                    />
                                    <span className="switch-slider"></span>
                                </label>
                                <span className={`switch-status ${switchState ? 'active' : 'inactive'}`}>
                                    {switchState ? t('deliveryTime.enabled') : t('deliveryTime.disabled')}
                                </span>
                            </div>
                            <p className="switch-help-text">
                                {t('deliveryTime.autoAcceptHelp')}
                            </p>
                        </div>

                    </form>
                </div>

                {/* Botões de Ação - No rodapé */}
                <div className="modal-tempo-entrega-footer">
                    <button
                        className="btn-modern btn-cancel"
                        type="button"
                        onClick={closeEditTempoEntrega}
                    >
                        {t('buttons.cancel')}
                    </button>
                    <button
                        className="btn-modern btn-save"
                        type="submit"
                        form="tempo-entrega-form"
                    >
                        <AiIcons.AiOutlineSave />
                        {t('deliveryTime.saveChanges')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ModalEditTempoEntrega;